// 4-state lifecycle (#42 / #49). The backend computes this in
// `sections/scope/storage.compute_report_status` and ships it as
// `lifecycle_status`. We fall back to the local derivation only when
// talking to an older API that doesn't ship the field yet.
import type { Report, ReportLifecycle } from "@/core/api/types";

const LIFECYCLE_VALUES: ReadonlySet<ReportLifecycle> = new Set([
  "AI processing",
  "AI ready",
  "in progress",
  "complete",
  "awaiting upload",
]);

export function lifecycleOf(r: Report): ReportLifecycle {
  if (r.lifecycle_status && LIFECYCLE_VALUES.has(r.lifecycle_status as ReportLifecycle)) {
    return r.lifecycle_status as ReportLifecycle;
  }
  if (r.completed_at) return "complete";
  // #105: an A8 carve-out placeholder is awaiting the user's upload, not the AI.
  if (r.status === "awaiting_upload") return "awaiting upload";
  if (r.status === "uploading" || r.status === "processing") return "AI processing";
  if (r.status === "error") return "AI processing";
  if (r.user_touched || (r.open_action_items ?? 0) > 0) return "in progress";
  return "AI ready";
}

export function lifecycleColor(
  s: ReportLifecycle
): "in-progress" | "info" | "pending" | "success" | "warning" {
  switch (s) {
    case "AI processing":
      return "in-progress";
    case "AI ready":
      return "info";
    case "in progress":
      return "pending";
    case "awaiting upload":
      return "pending";
    case "complete":
      return "success";
  }
}
